import { actions, actionTypes } from "../actions";
import { RewardsAccount } from "redmond";

export interface IPackagesRewardsState {
  rewardsAccounts: RewardsAccount[];
  selectedAccountReferenceId: string | null;
  fetchRewardsAccountsCallState: CallState;
  isFirstLaunch: boolean;
  agentEmail: string;
}

export enum CallState {
  NotCalled,
  InProcess,
  Success,
  Failed,
}

const initialState: IPackagesRewardsState = {
  rewardsAccounts: [],
  selectedAccountReferenceId: null,
  fetchRewardsAccountsCallState: CallState.NotCalled,
  isFirstLaunch: false,
  agentEmail: "",
};

export function reducer(
  state: IPackagesRewardsState = initialState,
  action: actions.PackagesRewardsActions
): IPackagesRewardsState {
  switch (action.type) {
    case actionTypes.SET_IS_FIRST_LAUNCH:
      return {
        ...state,
        isFirstLaunch: action.isFirstLaunch,
      };

    case actionTypes.SET_AGENT_EMAIL:
      return {
        ...state,
        agentEmail: action.agentEmail,
      };

    case actionTypes.FETCH_REWARDS_ACCOUNTS:
      return {
        ...state,
        fetchRewardsAccountsCallState: CallState.InProcess,
      };

    case actionTypes.SET_FETCH_REWARDS_ACCOUNTS_CALL_STATE_FAILED:
      return {
        ...state,
        fetchRewardsAccountsCallState: CallState.Failed,
      };

    case actionTypes.SET_REWARDS_ACCOUNTS:
      return {
        ...state,
        rewardsAccounts: action.rewardsAccounts,
        fetchRewardsAccountsCallState: CallState.Success,
      };

    case actionTypes.SET_SELECTED_ACCOUNT_REFERENCE_ID:
      return {
        ...state,
        selectedAccountReferenceId: action.selectedAccountReferenceId,
      };

    default:
      return state;
  }
}

export * from "./selectors";
